import { t } from '@/core/localization';
import { InvoiceType } from '@/warehouse/modules/crossdockReceipt/models';
export const getInvoiceTypeName = (invoiceType) => {
    return invoiceType === InvoiceType.Return ? t('refund.label') : t('utd.abbr');
};
